<app-vis-dialog
  title="批號分配"
  [show]="show"
  (open)="onDialogOpen()"
  (close)="closeDialog()"
  [width]="0"
  [superWidth]="'50%'"
  [height]="'auto'"
  [maxWidth]="'90vw'">

  <div class="p-2">
    <!-- 進度提示 -->
    <div *ngIf="isLoading" class="text-center p-2 text-muted">載入中…</div>

    <!-- 合計提示列 -->
    <div class="alloc-summary mb-2" *ngIf="!isLoading">
      <span>應分配: <strong>{{ requiredQty | number:'1.0-0':'en-US' }}</strong></span>
      <span>已分配: <strong [class.text-danger]="allocatedQty > requiredQty">{{ allocatedQty | number:'1.0-0':'en-US' }}</strong></span>
      <span *ngIf="unassignedQty > 0" class="alloc-summary-unassigned text-danger">未指定: {{ unassignedQty | number:'1.0-0':'en-US' }}</span>
      <!-- 確認被擋住的原因：併入合計列同一行（訊息過長時整列 flex-wrap 自動換行） -->
      <span *ngIf="errorMessage" class="alloc-summary-error text-danger">
        <mat-icon class="alloc-error-icon">warning</mat-icon>{{ errorMessage }}
      </span>
      <!-- 新增分配列按鈕 (同商品手動拆多批號)：靠右對齊，icon 與明細「新增」鈕一致。
           組合商品分配列固定、只可選批號，不提供新增。 -->
      <button type="button"
        *ngIf="!isCombination"
        class="vis-btn-config p-0 position-relative pl-2 w-28 alloc-add-btn"
        title="針對最後一列商品新增一列 (同商品拆多批)"
        (click)="addLastProductRow()">
        <mat-icon class="pref-icon add vis-combine-icon">add_circle</mat-icon>
        <span class="position-absolute text-xs-sm start-0 ml-4 pl-2 add-row-label">新增分配列</span>
      </button>
    </div>

    <!-- 母商品的母子換算說明 (批號掛在子商品上，分配列顯示的是子商品) -->
    <div class="alloc-parent-hint mb-2" *ngIf="!isLoading && parentConversionHint">{{ parentConversionHint }}</div>

    <!-- 分配列表 (app-vis-grid) -->
    <div *ngIf="!isLoading">
      <div class="batch-alloc-grid-wrap">
        <app-vis-grid [data]="rows" class="batch-alloc-grid">
          <app-vis-grid-column field="ProductName" title="商品名稱" [width]="250">
            <ng-template let-data>
              <div class="ellipsis-content" [title]="data.ProductName">
                <app-stocks-product-tags [product]="data._product"></app-stocks-product-tags>
                {{ data.ProductName }}
              </div>
            </ng-template>
          </app-vis-grid-column>
          <app-vis-grid-column field="BatchNo" title="批號" [width]="150">
            <ng-template let-data>
              <div [class.batch-cell-unassigned]="data.IsUnassigned">
                <app-stocks-batch-select
                  [productId]="data.ProductId"
                  [storeRoomId]="storeRoomId"
                  [allowUnassigned]="true"
                  [excludeExpired]="!inboundMode"
                  [referenceDate]="referenceDate"
                  [externalBatches]="availableBatchesByProduct ? (availableBatchesByProduct[data.ProductId] || null) : null"
                  [batchCeiling]="batchCeiling"
                  [unassignedQty]="unassignedQtyMap ? unassignedQtyMap[data.ProductId] : null"
                  [disabled]="false"
                  [displayValue]="data.IsUnassigned ? '未指定' : data.BatchNo"
                  (batchSelected)="onRowBatchSelected(data, $event)">
                </app-stocks-batch-select>
              </div>
            </ng-template>
          </app-vis-grid-column>
          <app-vis-grid-column field="Qty" title="數量" [width]="90">
            <ng-template let-data>
              <input
                type="number"
                class="vis-input text-right"
                [class.over-stock-input]="data._overStock"
                style="width: 80px;"
                [disabled]="data.IsUnassigned || isCombination"
                [title]="data.IsUnassigned ? '未指定量 = 應分配 − 常規批已分配 (自動計算)' : (isCombination ? '組合商品數量由組合比例決定，不可修改' : '')"
                [(ngModel)]="data.Qty"
                (ngModelChange)="onQtyChange()"
                min="0"
                [attr.max]="data.AvailableQty !== null && data.AvailableQty !== undefined ? data.AvailableQty : null" />
            </ng-template>
          </app-vis-grid-column>
          <app-vis-grid-column field="ExpirationDate" title="效期" [width]="90">
            <ng-template let-data>
              {{ data.ExpirationDate | formatROCFullDate:'/' }}
            </ng-template>
          </app-vis-grid-column>
          <app-vis-grid-column *ngIf="!isCombination" title="刪" [width]="30">
            <ng-template let-data let-index="index">
              <div class="text-center">
                <button type="button"
                  class="my-1 text-xs btn-grid btn-grid-cancel px-1 background-none"
                  title="刪除"
                  (click)="removeRow(index)">
                  <mat-icon class="vis-combine-icon d-inline-flex" title="刪除">cancel</mat-icon>
                </button>
              </div>
            </ng-template>
          </app-vis-grid-column>
          <div no-data *ngIf="rows.length === 0 && unassignedQty === 0"
            class="text-center text-muted p-2">
            尚無分配資料
          </div>
        </app-vis-grid>
      </div>
    </div>

  </div>

  <app-vis-dialog-actions>
    <button type="button"
      [disabled]="!canConfirm"
      (click)="confirmAllocate()">確定</button>
    <button type="button"
      (click)="closeDialog()">取消</button>
  </app-vis-dialog-actions>
</app-vis-dialog>
